"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("@paprika/helpers");

/* eslint-disable react/require-default-props */

/* eslint-disable react/no-unused-prop-types */
var propTypes = {
  backdropClassName: _propTypes["default"].string,
  children: _propTypes["default"].func,

  /** container of the Overlay element */
  container: _propTypes["default"].node,
  focusLockOptions: _propTypes["default"].shape(_helpers.FocusPropTypes),
  hasBackdrop: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onAfterOpen: _propTypes["default"].func,
  onAfterClose: _propTypes["default"].func,

  /** The z-index of the Panel Overlay */
  zIndex: _propTypes["default"].number
};
var defaultProps = {};

var Overlay = function Overlay() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
};

var _default = Overlay;
exports["default"] = _default;
Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
Overlay.displayName = "Panel.Overlay";
//# sourceMappingURL=Overlay.js.map